export const themeColor = '#024218';
export const guidePostColor = '#2f76c1';
export const topGradientColor = '#dfffe6';

